// extracted by mini-css-extract-plugin
export default {"callout":"callout--CQ4xn","header":"header--j4P3w","title":"title--SCLcu","content":"content--S9yD5","variantWarning":"variantWarning--jiKiP"};